// @flow
import React, { Component } from 'react';
import BrandCardList from 'components/common/BrandCardList/BrandCardList';
import type { State } from 'store';
import { BrandingActions } from 'store/actionCreators';
import type { BrandItem } from 'store/modules/branding';
import { connect } from 'react-redux';
import throttle from 'lodash/throttle';
import { getScrollBottom, preventStickBottom } from 'lib/common';

type OwnProps = {
  sort: string,
  category: string,
};

type Props = OwnProps & {
  brands: ?(BrandItem[]),
  prefetched: ?(BrandItem[]),
  prefetching: boolean,
  loading: boolean,
  width: number,
  hasEnded: boolean,
  shouldCancel: boolean,
};

class BrandingBrandCards extends Component<Props> {
  prevCursor: ?string = null;

  prefetch = async () => {
    const { brands, prefetching, loading, category, sort } = this.props;
    if (!brands || brands.length === 0 || prefetching || loading) return;
    const lastId = brands[brands.length - 1].id;
    if (this.props.prefetched) {
      BrandingActions.revealPrefetched('recent');
      await Promise.resolve(); // next tick
    }
    if (lastId === this.prevCursor) return;
    this.prevCursor = lastId;
    try {
      await BrandingActions.prefetchRecentBrands(lastId, category, sort);
    } catch (e) {
      console.log(e);
    }
    preventStickBottom();
    this.onScroll();
  };

  onScroll = throttle(() => {
    const scrollBottom = getScrollBottom();
    if (scrollBottom > 1000) return;
    this.prefetch();
  }, 250);

  initialize = async () => {
    const { brands, shouldCancel, category, sort } = this.props;
    try {
      if (brands && brands.length > 0) {
        // do not fetch brand data when already exists
        return;
      }
      if (!shouldCancel) {
        await BrandingActions.getRecentBrands('', category, sort);
      }
      this.prefetch();
    } catch (e) {
      console.log(e);
    }
  };

  listenScroll = () => {
    window.addEventListener('scroll', this.onScroll);
  };

  unlistenScroll = () => {
    window.removeEventListener('scroll', this.onScroll);
  };

  listenSort = async () => {
    const { category, sort } = this.props;
    await BrandingActions.getRecentBrands('', category, sort);
    this.prefetch();
  };

  componentDidMount() {
    this.initialize();
    this.listenScroll();
  }

  componentWillUnmount() {
    this.unlistenScroll();
  }

  componentDidUpdate(prevProps) {
    if (prevProps.sort !== this.props.sort) {
      this.listenSort();
    }
  }

  render() {
    return (
      <BrandCardList
        brands={this.props.brands}
        loading={this.props.loading}
        prefetching={
          (this.props.prefetched && this.props.prefetched.length > 0) || this.props.prefetching
        }
        width={this.props.width}
        hasEnded={this.props.hasEnded}
      />
    );
  }
}

const mapStateToProps = ({ branding, pender, base, common }: State) => ({
  brands: branding.recent.brands,
  prefetched: branding.recent.prefetched,
  prefetching: pender.pending['branding/PREFETCH'],
  loading: pender.pending['branding/GET_RECENT_POSTS'],
  width: base.windowWidth,
  hasEnded: branding.recent.end,
  shouldCancel: common.ssr && !common.router.altered,
});

export default connect(mapStateToProps, () => ({}))(BrandingBrandCards);



// WEBPACK FOOTER //
// ./src/containers/list/BrandingBrandCards.js